import React, { memo, forwardRef } from "react";
const SvgVector = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M19.135 5.4a1 1 0 011.4-.2l4 3a1 1 0 010 1.6l-4 3a1 1 0 01-1.2-1.6l1.686-1.265H8.935a.935.935 0 010-1.87h12.086L19.335 6.8a1 1 0 01-.2-1.4z"
      />
      <rect width={10} height={14} x={11} y={15} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgVector.displayName = "SvgVector";
const MemoForwardRef = memo(SvgVector);
export default MemoForwardRef;
